import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { useSettingsStore } from '@/store/modules/settings';

import { useFullscreen } from '@vueuse/core';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const {
      isFullscreen,
      toggle
    } = useFullscreen();
    const settingsStore = useSettingsStore();
    const {
      theme
    } = storeToRefs(settingsStore);
    return (_ctx, _cache) => {
      const _component_vab_icon = _resolveComponent("vab-icon");
      return _unref(theme).showFullScreen ? (_openBlock(), _createBlock(_component_vab_icon, {
        key: 0,
        icon: _unref(isFullscreen) ? 'fullscreen-exit-fill' : 'fullscreen-fill',
        onClick: _unref(toggle)
      }, null, 8, ["icon", "onClick"])) : _createCommentVNode("", true);
    };
  }
});